import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import './TiersGameStyles.scss';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

const TiersSingleEntryView = ({
    entry,
    league,
    theCurrentInterval,
    theCurrentIntervalsInfo,
    setIndexToRemove,
    setRemoveModalOpen,
    isThisPoolPartyGame,
    pickIndex,
    isUserAdmin,
    findMyRank,
    findMyScore,
    picksToMakeTheCurrentInterval,
    getGolfersAlive,
    myLeaderboardInfo,
    totalEntriesCount,
    hasCurrentIntervalStarted,
    originalPicks,
    hasJoinDeadlinePassed,
    oneIntervalEvent,
    isUserOnOverallLeaderboard,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(768));
    //console.log("The CurrentIntervalsInfo", theCurrentIntervalsInfo, "The Current Interval", theCurrentInterval);

    const picksThisInterval = originalPicks?.filter(pick =>
        pick.interval === theCurrentInterval && pick.id && !pick.id.startsWith('no-pick')
    )?.length || 0;
    //console.log("Picks this interval", picksThisInterval, "Original picks", originalPicks);

    const allPicksMade = picksThisInterval === picksToMakeTheCurrentInterval;

    const handleRemovedClick = (index) => {
        setIndexToRemove(index);
        setRemoveModalOpen(true);
    };


    return (
        <Box>
            <Box className="tiers-single-entry-container">
                <Box className="tiers-single-entry-content">
                    {(isUserOnOverallLeaderboard || oneIntervalEvent) && (
                        <Box className="tiers-single-entry-column">
                            <Typography className="tiers-single-entry-header-text">
                                {!oneIntervalEvent ? 'Overall' : 'Rank'}
                            </Typography>
                            {!oneIntervalEvent && (
                                <Typography className="tiers-single-entry-text">
                                    {findMyScore(myLeaderboardInfo, entry?.name)}
                                </Typography>
                            )}
                            <Typography className="tiers-single-entry-text">
                                {findMyRank(myLeaderboardInfo, entry?.name)} of {totalEntriesCount}
                            </Typography>
                        </Box>
                    )}
                    {oneIntervalEvent && (
                        <Box className="tiers-single-entry-column">
                            <Typography className="tiers-single-entry-header-text">
                                Score
                            </Typography>
                            <Typography className="tiers-single-entry-text">
                                {findMyScore(myLeaderboardInfo, entry?.name)}
                            </Typography>
                        </Box>
                    )}

                    {!oneIntervalEvent && (
                        <Box className="tiers-single-entry-column">
                            <Typography className="tiers-single-entry-header-text">
                                {theCurrentIntervalsInfo?.shortLabel}
                            </Typography>
                            <Typography className="tiers-single-entry-text">
                                {findMyScore(myLeaderboardInfo, entry?.name, theCurrentInterval)}
                            </Typography>
                            <Typography className="tiers-single-entry-text">
                                {findMyRank(myLeaderboardInfo, entry?.name, theCurrentInterval)} of {totalEntriesCount}
                            </Typography>
                        </Box>
                    )}

                    {!hasCurrentIntervalStarted && picksToMakeTheCurrentInterval && (
                        <Box className="tiers-single-entry-column">
                            <Typography className="tiers-single-entry-header-text">
                                Golfers
                            </Typography>
                            <Typography 
                                className="tiers-single-entry-text"
                                sx={{ color: allPicksMade ? '#00AA72' : '#CC293C' }}
                            >
                                {picksThisInterval}/{picksToMakeTheCurrentInterval}
                                {allPicksMade ? (
                                    <CheckIcon className="tiers-single-entry-icon" />
                                ) : (
                                    <CloseIcon className="tiers-single-entry-icon" />
                                )}
                            </Typography>
                        </Box>
                    )}
                    {hasCurrentIntervalStarted && (
                        <Box className="tiers-single-entry-column">
                            <Typography className="tiers-single-entry-header-text">
                                Alive
                            </Typography>
                            <Typography className="tiers-single-entry-text">
                                {getGolfersAlive(originalPicks)}/{picksThisInterval}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            {!hasJoinDeadlinePassed && !isThisPoolPartyGame && !isUserAdmin && (
                <Typography 
                    onClick={() => handleRemovedClick(Number(pickIndex))}
                    sx={{
                        color: "#CC293C",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: isMobile ? '12px' : '18px',
                        fontWeight: "500",
                        width: '100%',
                        textAlign: 'center',
                        paddingBottom: '10px'
                    }}
                >
                    Remove
                </Typography>
            )}
        </Box>
    );
}

export default TiersSingleEntryView;
